import bodymovin from 'lottie-web';

export function ezDebounce(fn, time) {
  let timeout;

  return (...args) => {
    const functionCall = () => fn.apply(this, args);

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
}

export function getWindowWidth() {
  return window.innerWidth
  || document.documentElement.clientWidth
  || document.body.clientWidth;
}

export function getWindowHeight() {
  return window.innerHeight
  || document.documentElement.clientHeight
  || document.body.clientHeight;
}

export function addListenerMulti(el, s, fn) {
  s.split(' ').forEach((e) => { el.addEventListener(e, fn, false); });
}

export function removeListenerMulti(el, s, fn) {
  s.split(' ').forEach((e) => { el.removeEventListener(e, fn, false); });
}

export function detectIE() {
  const ua = window.navigator.userAgent;

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

export function getChromeVersion() {
  const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  return raw ? parseInt(raw[2], 10) : false;
}

export function isScrolledIntoView(elem) {
  const rect = elem.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;

  // Only completely visible elements return true:
  const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
  // Partially visible elements return true:
  // isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}

export function ezFadeOut(element, speed, callback = () => {}) {
  const s = element.style;

  s.opacity = 1;

  /* eslint-disable func-names */
  (function fade() {
    s.opacity -= 0.1;

    if (s.opacity < 0) {
      s.display = 'none';

      callback();
    } else {
      setTimeout(fade, speed);
    }
  }());
  /* eslint-enable func-names */
}

export function getFormattedPageValue(currentPageElem) {
  let value = currentPageElem.innerHTML; // grab the contents
  value = value.replace(/\s/g, ''); // remove all whitespace
  value = value.replace(/[\n\r]/g, ''); // remove line returns

  return parseInt(value, 10);
}

export function postAjax(eventName, dataHash, addPushState) {
  const postAjaxEvent = new CustomEvent(eventName, {
    detail: { dataHash, addPushState },
  });
  window.dispatchEvent(postAjaxEvent);
}

export function triggerCustomEvent(eventName, detailsHash = {}, elem = window) {
  const event = new CustomEvent(eventName, {
    detail: detailsHash,
  });
  elem.dispatchEvent(event);
}

export function makeQueryParams(dataHash, exclude = []) {
  let params = Object.keys(dataHash)
    .filter((key) => {
      if (exclude.includes(encodeURIComponent(key))) {
        return false;
      }

      return true;
    })
    .map(
      key => `${encodeURIComponent(key)}=${encodeURIComponent(dataHash[key])}`,
    )
    .join('&');

  if (params.length) {
    params = `?${params}`;
  }

  return params;
}

export function printElem(elem, title, printStylesheet) {
  const windowLocation = {
    left: (window.screen.availWidth / 2) - 50,
    top: (window.screen.availHeight / 2) - 300,
  };

  const mywindow = window.open('', 'PRINT', `height=700, width=1000, left=${windowLocation.left}, top=${windowLocation.top}`);

  mywindow.document.write(`<html><head><title>${title}</title>`);
  mywindow.document.write('<style media="print">body { display: block!important; }</style>');

  if (printStylesheet) {
    mywindow.document.write(printStylesheet);
  }

  mywindow.document.write('</head><body style="display: none;">');
  mywindow.document.write(`<h1>${title}</h1>`);

  mywindow.document.write(elem.innerHTML);

  mywindow.document.write('</body></html>');

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  setTimeout(() => { // Set a timeout to allow print stylesheet to load up
    mywindow.print();
    mywindow.close();
  }, 300);

  return true;
}

export function smoothScroll(ypos) {
  setTimeout(() => {
    window.scrollTo({ top: ypos, behavior: 'smooth' });
  }, 1);
}

export function initSvgAnim(container, animationData, loop = false, autoplay = true) {
  return bodymovin.loadAnimation({
    container,
    renderer: 'svg',
    loop,
    autoplay,
    animationData,
  });
}

export function parseTemplate(string, item) {
  return string.replace(/\{\{(\w+)\}\}/g, (a, b) => item[b]);
}
